import { motion } from 'framer-motion';

export function HeroSection() {
  return (
    <section className="relative overflow-hidden border-b border-border">
      {/* Soft brand glow — same recipe as Case Overview cards, scaled up. */}
      <div
        aria-hidden
        className="pointer-events-none absolute left-1/2 top-0 z-0"
        style={{
          width: '1400px',
          height: '420px',
          transform: 'translateX(-50%)',
          borderRadius: '1400px',
          opacity: 0.18,
          background: '#3B82F6',
          filter: 'blur(120px)',
        }}
      />

      <div className="relative z-10 mx-auto flex max-w-6xl flex-col gap-8 px-8 py-16 sm:py-24">
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
          className="flex flex-col gap-6"
        >
          <h1 className="max-w-3xl text-4xl font-semibold leading-tight tracking-tight text-ink-strong sm:text-5xl">
            Annual savings per firm
          </h1>
          <p className="max-w-2xl text-base leading-relaxed text-ink">
            Use validated market assumptions as a starting point, then adjust
            case volume, charge-out rates, and hours per case while the Asset
            Hound saving percentage stays fixed by profile
          </p>
        </motion.div>
      </div>
    </section>
  );
}
